module.exports = __webpack_public_path__ + "static/blue_abishai-f1308befaae8900362d8cf93aadc6a6e.png";